import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { useEffect } from 'react';
// @ts-expect-error Untyped module
import { updateIsTrellisTheme } from '../redux/actions/inpageActions';
import { useDispatch } from 'react-redux';
const ThemeIframeCoordinator = () => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateIsTrellisTheme(isTrellis));
  }, [dispatch, isTrellis]);
  return null;
};
export default ThemeIframeCoordinator;